import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import About_us from './About us/About_us.jsx';
import Contact from './Contact/Contact.jsx';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './Navabar/Navbar.jsx';
import Services from './Service/Service.jsx';
import Main from './Home/Main.jsx';
import Footer from './Fotter/Fotter.jsx';
import Dummy from './developing/dummy.jsx';
import ScrollToTop from './Scrolltop/Scroll.jsx';
import PrivacyPolicy from './Privary/Privary.jsx';
import Personalloan from './Personalloan/Personalloan.jsx';
import Homeloan from './Home loan/Homeloan.jsx';
import LoanDSAForm from './Loansa/Loandsa.jsx';
import HomeloanDsa from './Loansa/Homeloandsa.jsx';
import Businessloan from "./Loansa/GoldloanDsa.jsx"
import LifeInsurance from './Insurancces/Insurancesfull.jsx';
import InsurancePage from './Insurancces/Healthinsurance.jsx';
import HomeLoanPage from './Home loan/Homeloan.jsx';
import PersonalLoanPage from './Home loan/Personal.jsx';
import BusinessLoanPage from './Home loan/Businessloan.jsx';
import EducationLoanPage from './Home loan/Educationloan.jsx';
import CarLoanPage from './Home loan/Carloan.jsx';
import Chat from './Chat/Chat.jsx';
import Genralinsurance from './Insurancces/Genralinsurance.jsx';
import CarInsurance from './Insurancces/CarInsurance.jsx';

function App() {
  return (
    <Router> {/* Router should wrap everything */}
      <ScrollToTop />
      <HelmetProvider>
        <Navbar />
        <Routes>
          <Route path='/' element={<Main />} />
          <Route path='/about' element={<About_us />} />
          <Route path='/service' element={<Services/>}/>
          <Route path='/contact' element={<Contact />} />
          <Route path='/developing' element={<Dummy />} />
          <Route path='/privacy' element={<PrivacyPolicy />} />
          <Route path='/personalloan' element={<Personalloan />} />
          <Route path='/homeloan' element={<Homeloan />} />
          <Route path='/PersonalLoanDsa' element={<LoanDSAForm />} />
          <Route path='/BusinessLoanDsa' element={<Businessloan />} />
          <Route path='/HomeloanDsa' element={<HomeloanDsa />} />
          <Route path='/LifeInsurance' element={<LifeInsurance></LifeInsurance>} />
          <Route path='/HealthInsurance' element={<InsurancePage></InsurancePage>} />
          <Route path='/HomeLoanPage' element={<HomeLoanPage></HomeLoanPage>} />
          <Route path='/PersonalLoanPage' element={<PersonalLoanPage></PersonalLoanPage>} />
          <Route path='/BusinessLoanPage' element={<BusinessLoanPage></BusinessLoanPage>} />
          <Route path='/EducationLoanPage' element={<EducationLoanPage></EducationLoanPage>} />
          <Route path='/CarLoanPage' element={<CarLoanPage></CarLoanPage>} />
          <Route path='/chat' element={<Chat></Chat>} />
          <Route path='/Genralinsurance' element={<Genralinsurance></Genralinsurance>} />
          <Route path="/carinsurance" element={<CarInsurance></CarInsurance>}/>


       </Routes>
      </HelmetProvider>
      <Footer></Footer>
    </Router>
  );
}

export default App;
